import { cn } from "@/lib/utils";
import { type FC } from "react";
import { type ProgramStructure2Data } from "./_schema";

// Title Section Component
// One <h2> for both lines: the two halves are a single section heading, and SEO reads
// them as one. Spans, not <p>: a heading may only hold phrasing content. The flex
// column blockifies them, so the layout is unchanged.
export const TitleSection: FC<{ parsedData: ProgramStructure2Data }> = ({ parsedData }) => (
    <h2 className={cn(
        "flex flex-col mb-[24px]",
        "sm:mb-[28px]",
        "lg:mb-[36px]"
    )}>
        <span
            className={cn(
                "font-semibold leading-normal",
                "text-[24px]",
                "sm:text-[28px]",
                "md:text-[30px]",
                "lg:text-[30px]",
                "xl:text-[30px]"
            )}
            style={{
                color: parsedData.title_1_color,
                fontFamily: "var(--font-google-sans)"
            }}
        >
            {parsedData.title_1}
        </span>
        <span
            className={cn(
                "font-bold leading-[1.2] bg-clip-text text-transparent",
                "text-[40px] tracking-[1.2px]",
                "sm:text-[44px] sm:tracking-[1.32px]",
                "md:text-[54px] md:tracking-[1.62px]",
                "lg:text-[64px] lg:tracking-[1.92px]",
                "xl:text-[64px] xl:tracking-[1.92px]"
            )}
            style={{
                backgroundImage: parsedData.title_2_gradient_start_color && parsedData.title_2_gradient_end_color ?
                    `linear-gradient(to right, ${parsedData.title_2_gradient_start_color}, ${parsedData.title_2_gradient_end_color})` :
                    undefined,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontFamily: "var(--font-merriweather)"
            }}
        >
            {parsedData.title_2}
        </span>
    </h2>
);
